// extracted by mini-css-extract-plugin
export var legendIndicator = "_cu-1";
export var legendRight = "_cu-0";